var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{on:{"click":_vm.search}},[_vm._v("搜索")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }